window.VH = window.VH === undefined ? {} : window.VH;
VH.Helper = {
    w : $(window),
    d : $(document),
    b : $('body'),

    Select2ClassOption : function Select2ClassOption(data, container) {
        if (data.element) {
            $(container).addClass($(data.element).attr('class'));
        }
        return data.text;
    },

    Select2OnChangeClass : function Select2OnChangeClass(s2) {
        let container = s2.parent().find('>.select2-container .select2-selection');
        container
            .attr('class', container.attr('class').replace(/\bborder\-left\-\w+\b/g, ''))
            .addClass(s2.find(':selected').attr('class'));
    },

    initContentTooltip : function initContentTooltip()
    {
        $('.uContentTooltip').each(function() {
            let t = $(this);
            t.tooltip({title:t.html()});
        });
    }

};
